export enum ConnectionStatus {
  NOT_CONNECTED = "NOT_CONNECTED",
  PENDING_SETUP = "PENDING_SETUP",
  CONNECTED = "CONNECTED",
  CONNECTING = "CONNECTING",
  PENDING_SCHEMA_UPDATE = "PENDING_SCHEMA_UPDATE",
  PENDING_RECONNECT = "PENDING_RECONNECT",
}

/**
 * Written by the API after an Instagram Insights OAuth reconnect for ANOTHER
 * company narrowed the shared Meta login's asset selection (Meta stores one
 * selection per person + app) so that this connector's Instagram account is
 * no longer covered. Cleared by the API once a later grant covers it again.
 * Public-DTO field; carries ids and a timestamp only, never a credential.
 */
export type CompanyConnectorCredentialGrantWarning = {
  /** ISO timestamp of the check that found the account missing. */
  checkedAt: string
  /** This connector's `metadata.igUserId`, absent from the new grant. */
  missingIgUserId: string
  // The company whose reconnect produced the narrower grant stays inside the
  // API (super admins get it in the notification): one tenant's id is never
  // serialized into another tenant's connector row.
}

export type CompanyConnectorMetadata = {
  createdByMigration?: boolean
  migrationSource?: string
  credentialGrantWarning?: CompanyConnectorCredentialGrantWarning | null
  [key: string]: unknown
}

export type CompanyConnectorDto = {
  id: string
  serviceName: string
  companyId: string
  metadata: CompanyConnectorMetadata
  lastSuccessfulSyncDate: string
  isCompleted: boolean
  status: ConnectionStatus
  createdAt: string
  updatedAt: string
  confirmedAt?: string
  scopeVersion?: number
}

export type CompanyConnectCardDto = {
  uri: string
  token: string
  companyConnectorId: string
  requiresPreConfig?: boolean
}

export type CompanyConnectorStatusDto = {
  connectorId: string
  connectorType: string
  setupState: string
  syncState: string
  updateState: string
  lastSuccessfulSyncDate: string
  nextAction: string
  warnings?: Array<{ message: string }>
}

export type AccountInfoDto = {
  metric: string
  avatarUrl: string
  accountName: string
}
